export const DEFAULT_BORDER_RADIUS = "25px";
